import { toRefs, reactive, markRaw, onUnmounted } from 'vue';
import { codeKeys, codeList } from '../code';
import 'vant/es/toast/style';
import { showToast } from 'vant';
import { getInviteVCode, validateInvite } from '../clientApi';
import { openApp, jsdk } from '../util';
import qs from 'qs';
export default {
  setup() {
    let timer = null;
    const state = reactive({
      showPanel: false,
      tel: '',
      code: '',
      city: {
        countryCode: '86',
        countryName: '中国大陆'
      },
      codeKeys: markRaw(codeKeys),
      codeList: markRaw(codeList),
      countdown: 0,
      queryParams: {},
      result: '',
      resDialogClass: '',
      resContentClass: '',
      bgClass: '',
      submitText: '领取积分',
      introText: '',
      mainImgClass: '',
      subImgClass: 'hide-img',
      thirdImgClass: 'hide-img',
      codeImgClass: 'hide-img',
      ruleTextClass: '',
      ruleText: `<p>规则说明：</p>
                  <p>1.未注册过的手机号，在该页面完成手机号验证后，需要下载潮新闻客户端登录成功后才能领取积分使用，不能重复领取，只能领取一次。</p>
                  <p>2.已注册过的手机号，如果在APP上已经参与过邀请好友活动，填写过邀请码，就不能再次领取邀请好友积分。</p>
                <p>3.已注册过的手机号，如果未在APP上参与过邀请好友活动，即未填写过邀请码，仍然可以再次领取邀请好友积分。</p>`
    });
    const {
      search
    } = window.location;
    const queryStartIndex = search.indexOf('?');
    if (queryStartIndex >= 0) {
      state.queryParams = qs.parse(search.substring(queryStartIndex + 1));
    }
    if (state.queryParams.invite_code) {
      state.introText = '我在潮新闻上送了您50积分！快来下载潮新闻，填写我的邀请码：' + state.queryParams.invite_code + '，即可领取积分！';
      let shareData = {
        title: '我在潮新闻上送了您50积分！',
        summary: '快来下载潮新闻，填写我的邀请码，即可领取积分！',
        imgUrl: 'https://activity.tianmunews.com/material/2023smilingface/img/tide_logo.png',
        link: window.location.href
      };
      switch (state.queryParams.invite_code) {
        case 'hangzhou0004':
          state.bgClass = 'invite-hangzhou';
          state.submitText = '参与投稿';
          state.introText = '快来下载潮新闻，输入手机号并验证，即可参与投稿！';
          break;
        case 'wenzhou':
          state.resDialogClass = 'result-dialog-wenzhou';
          state.resContentClass = 'result-content-wenzhou';
          state.submitText = '马上参与';
          state.introText = '我在潮新闻上参加温州百万学生迎亚运活动，快来转发，一起向名师发起挑战。';
          state.mainImgClass = 'hide-img';
          state.subImgClass = '';
          state.ruleTextClass = 'rule-text-wenzhou';
          break;
        case 'hangzhou0002':
          state.bgClass = 'invite-hangzhou2';
          state.submitText = '完成验证';
          state.mainImgClass = 'hide-img';
          state.codeImgClass = 'code-img-hangzhou-2';
          // state.thirdImgClass = '';
          state.introText = '2023年7月31日至8月31日，杭州市地铁集团联合浙报集团杭州分社开展“‘潮’人绿色出行 跟着地铁玩转亚运”系列活动之“杭州地铁一日票”抽奖活动。凡下载潮新闻APP，完成用户注册并填写邀请码hangzhou0002，即可参与“杭州地铁一日票”抽奖。数量有限，领完为止。';
          break;
        case 'hangzhou0003':
          state.bgClass = 'invite-hangzhou3';
          state.submitText = '完成验证';
          state.mainImgClass = 'hide-img';
          state.codeImgClass = 'code-img-hangzhou-3';
          state.introText = '最潮实习生来袭！快来下载潮新闻客户端，即可进行报名！';
          state.ruleText = `<p>规则说明：</p>
                  <p>本次活动需要您下载潮新闻客户端进行报名，完成下载后，请使用注册手机号登录app，并在客户端顶部搜索页面输入“最潮实习生”关键词，重新找到这条推文，点击文内链接进行报名；或者扫描文内二维码进行报名。</p>`;
          shareData = {
            title: '最潮实习生来袭！',
            summary: '快来下载潮新闻，填写我的邀请码即可进行报名！',
            imgUrl: 'https://activity.tianmunews.com/material/2023smilingface/img/tide_logo.png',
            link: window.location.href
          };
          break;
      }
      jsdk(shareData);
    }
    const handleToggleShowPanel = isShow => {
      document.body.style.overflow = isShow ? 'hidden' : 'initial';
      state.showPanel = isShow;
    };
    const handleCityItemClick = item => {
      state.city = item;
      handleToggleShowPanel(false);
    };
    const getCode = async () => {
      const {
        tel,
        city: {
          countryCode
        }
      } = state;
      if (!/^\d{11}$/.test(tel) || state.countdown > 0) {
        return;
      }
      const res = await getInviteVCode({
        phone_number: tel,
        internation_code: countryCode
      });
      if (res.code === 0) {
        showToast('发送成功');
        state.countdown = 60;
        timer = setInterval(() => {
          state.countdown -= 1;
          if (state.countdown <= 0) {
            clearInterval(timer);
            timer = null;
          }
        }, 1000);
      } else {
        showToast(res.message);
      }
    };
    const submit = async () => {
      const {
        tel,
        code,
        city: {
          countryCode
        },
        queryParams
      } = state;
      if (!/^\d{11}$/.test(tel) || code.length === 0) {
        return;
      }
      const res = await validateInvite({
        phone_number: tel,
        verification_code: code,
        ref_code: queryParams.invite_code,
        internation_code: countryCode
      });
      if (res.code === 0) {
        state.result = '积分已放到您的手机账号上，快去下载或打开潮新闻APP领取吧！';
      } else if (res.code === 52014) {
        state.result = '您已领取过积分啦，快打开APP登录去吧！';
      } else if (res.code === 52020) {
        state.result = '您已领取过积分啦，快打开APP登录去吧！';
      } else {
        showToast(res.message);
      }
    };
    onUnmounted(() => {
      clearInterval(timer);
    });
    return {
      ...toRefs(state),
      handleToggleShowPanel,
      handleCityItemClick,
      getCode,
      submit,
      openApp
    };
  }
};